import script from "./ParsleyNewItemsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsleyNewItemsTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import EmptyState from "@/components/neue/EmptyState.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueNumberedPagination from "@/components/neue/NeueNumberedPagination.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
script.components = Object.assign({}, { EmptyState, InputField, NeueButton, NeueLoading, NeueNumberedPagination, SelectInput }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { EmptyState, InputField, NeueButton, NeueLoading, NeueNumberedPagination, SelectInput }, script.__o.components);}